import { FC, useState } from "react";
import Modal from "../../../components/shared/Modal/Modal";
import StyledCheckbox from "../../../components/shared/StyledCheckbox/StyledCheckbox";
import { ServiceUser } from "../../../services/service-user";
import appState from "../../../state/AppStateContainer";
import { useTranslation } from "react-i18next";
import styles from './SupplierAdPopUp.module.scss';

type Props = {
  show: boolean,
  setShow: (value: boolean) => void,
  areaName: string,
  municipalityName: string,
  setTabToRecommended: () => void,
  numberOfRecommendedSuppliers: number,
}

const SupplierAdPopUp: FC<Props> = ({ show, setShow, areaName, municipalityName, setTabToRecommended, numberOfRecommendedSuppliers }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'adPopUp' });
  const [isChecked, setIsChecked] = useState(false);

  const updateShowPreference = () => {
    ServiceUser.updatePreferences(appState.getUserId(), {preventPopUp: isChecked}, 'supplierAds');
  }

  return (
    <Modal
      title={t('title', 'Rekommenderade leverantörer')}
      show={show}
      setShow={(value) => {
        updateShowPreference();
        setShow(value);
      }}
      buttonInfo={{ label: t('button.show', 'Visa leverantörer'), action: () => {
        updateShowPreference();
        setTabToRecommended();
        setShow(false);
      }}}
    >
      <div style={{ display: 'flex', flexDirection: 'column', color: 'var(--gray-700)', gap: '16px'}}>
        <span>{t(
          'notice',
          'Du har {{numberOfRecommendedSuppliers}} leverantörer som vill lämna anbud på {{areaName}} i {{municipalityName}}',
          { numberOfRecommendedSuppliers, areaName, municipalityName }
          )}</span>
        <label className={styles.checkbox} style={{ letterSpacing: 0, color: 'var(--gray-700)' }}>
          <StyledCheckbox checked={isChecked} onChange={() => setIsChecked(prevState => !prevState)} />
          <span>{t('turnOff', 'Visa inte igen')}</span>
        </label>
      </div>
    </Modal>
  )
}

export default SupplierAdPopUp;
